import React from 'react';
import BeaconDropdownMetricColumnChart from 'src/components/BeaconV2Components/BeaconMetricColumnChart/BeaconDropdownMetricColumnChart';
import BeaconComparableSplineChart from 'src/components/BeaconV2Components/BeaconMetricSplineChart/BeaconComparableSplineChart';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { BeaconSplineChartWithPromotionsWrapper } from 'src/components/BeaconV2Components/ExperimentalLayout/Prices/Promotions/BeaconSplineChartWithPromotions';
import PricesSummaryProductGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Prices/Summary/PricesSummaryProductGrid';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import TopEntityChartV2Loading from 'src/components/BeaconV2Components/TopEntityChartV2/TopEntityChartV2Loading';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';

/**
 * Prices Summary Page
 */
const PricesSummaryPage = () => {
  return (
    <BasePageContainer>
      <Flex gap={BEACON_CHART_SPACING} flexDirection="column">
        <BeaconSplineChartWithPromotionsWrapper indexName="sales" fieldName="retailPrice" />
        <BeaconComparableSplineChart indexName="sales" fieldName="wholesalePrice" />
        <BeaconComparableSplineChart indexName="sales" fieldName="brandCogsPerUnit" />
        <BeaconComparableSplineChart indexName="sales" fieldName="brandGrossMarginPerUnit" />
        <BeaconDropdownMetricColumnChart
          beaconChartWithLegendPropsBuilder={(props) => ({
            ...props,
            loadingComponent: <TopEntityChartV2Loading />
          })}
          indexName="sales"
          fieldName="retailPrice"
          dropdownOptions={[
            {
              id: 'subCategoryId',
              label: 'Subcategory'
            },
            {
              id: 'categoryId',
              label: 'Category'
            },
            {
              id: 'brandId',
              label: 'Brand'
            }
          ]}
          titlePrefix="Retail Price by"
        />
        <PricesSummaryProductGrid />
      </Flex>
    </BasePageContainer>
  );
};

export default PricesSummaryPage;
